import { rowData, headerData } from "../../../../src/data/components/data-table.js";
import React from 'react';
export default {
  rowData,
  headerData,
  React
};